import React from 'react';
import Tile from './Tile';
import { TileGridProps } from './Types';

const TileGrid = ({ tiles, backgroundColor, tileFontStyle }: TileGridProps) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-8 p-4">
      {tiles.map((text) => (
        <Tile
          key={text}
          text={text}
          backgroundColor={backgroundColor || ''}
          tileFontStyle={tileFontStyle}
        />
      ))}
    </div>
  );
};

export default TileGrid;
